  let categoryBlocks2 = document.querySelectorAll(
  ".shop-by-category2 .category-block"
);
console.log(categoryBlocks2);
let categoryHeads2 = document.querySelectorAll(
  ".shop-by-category2 .category-head"
);
console.log(categoryHeads2);
categoryHeads2.forEach((el, ind) => {
  el.addEventListener("click", () => {
    let headButton = el;
    let targetId = el.dataset.block;
    categoryHeads2.forEach((el, ind) => {
      headButton == el
        ? el.classList.add("active")
        : el.classList.remove("active");
    });
    categoryBlocks2.forEach((el, ind) => {
      if (el.dataset.id == targetId) {
        el.classList.add("active");
        console.log("class added");
        el.style.opacity = "0";
        setTimeout(() => {
          el.style.opacity = "1";
        });
      } else {
        el.classList.remove("active");
      }
    });
  });
});